import * as React from "react"
import { Navigate } from "react-router-dom"

import { MANAGEMENT_ROUTES } from "@constants"
import AppLayout from "Layout"
import ManagementCustomerCrudsPage from "./CustomerCruds";
import ManagementKeywordsCrudPage from "./KeywordsCrud";
import ManagementPricingConfigPage from "./PricingConfig";
import ManagementSkuGroupCrudsPage from "./SkuGroupCruds";


export const ManagementRoutes = {
    path: MANAGEMENT_ROUTES.PATH,
    title: MANAGEMENT_ROUTES.TITLE,
    accessKey: MANAGEMENT_ROUTES.ACCESS_KEY,
    icon: 'screwdriver-wrench',
    iconWeight: 'light',
    element: <AppLayout />,
    description: "Management Module",
    children: [{
        element: <Navigate to={MANAGEMENT_ROUTES.CUSTOMER_CRUDS_PATH} replace/>, index: true
    }, {
        title: MANAGEMENT_ROUTES.CUSTOMER_CRUDS_TITLE,
        path: MANAGEMENT_ROUTES.CUSTOMER_CRUDS_PATH,
        dashboardKey: MANAGEMENT_ROUTES.CUSTOMER_CRUDS_ID,
        element: <ManagementCustomerCrudsPage />
    }, {
        title: MANAGEMENT_ROUTES.KEYWORDS_CRUDS_TITLE,
        path: MANAGEMENT_ROUTES.KEYWORDS_CRUDS_PATH,
        dashboardKey: MANAGEMENT_ROUTES.KEYWORDS_CRUDS_ID,
        element: <ManagementKeywordsCrudPage />
    }, {
        title: MANAGEMENT_ROUTES.SKU_GROUP_CRUDS_TITLE,
        path: MANAGEMENT_ROUTES.SKU_GROUP_CRUDS_PATH,
        dashboardKey: MANAGEMENT_ROUTES.SKU_GROUP_CRUDS_ID,
        element: <ManagementSkuGroupCrudsPage />
    }, {
        title: MANAGEMENT_ROUTES.PRICING_CONFIG_TITLE,
        path: MANAGEMENT_ROUTES.PRICING_CONFIG_PATH,
        dashboardKey: MANAGEMENT_ROUTES.PRICING_CONFIG_ID,
        icon: 'money-check-dollar',
        element: <ManagementPricingConfigPage />
    }]
}